
/**
 * @fileOverview mmmVideo module definition
 * Version 1.2
 * Date: March 31, 2014
 *
 * Update: 07/21/16 - MDPL-2899 (last updated)
 */

(function (context) {
	'use strict';
	var require = context.require;
	var requirejs = context.requirejs;
	var define = context.define;

	define('kungfu/video/mmmVideo',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function(require) {
		//define any required libraries - see config.js for registered names
        var $ = require('jquery'),  //require jQuery
            util = require('lib/Util'),    //require util for $debug
            GlobalEventDispatcher = require('GlobalEventDispatcher'),
			GlobalResizeListener = require('GlobalResizeListener'),
            vID,
            bcMod,
			experienceModule,
			bcModArr = [],
            player, APIModules, videoPlayer,
            randomNumber = $randomNumber(10000);

        //require domReady - which fires callback upon DOM being ready to fire our module
        require(['domReady!'], function (doc) {

            var url = 'https://sadmin.brightcove.com/js/BrightcoveExperiences.js',
				body = document.getElementsByTagName('body')[0],
				script = document.createElement('script');

			$.ajax({
                url: url,
                dataType: 'script',
                //cache : true,
            
                success: function () {
					//look for any of our js-elements to perform actions on
					$('.js-videoPlayer').each(function (i,element) {
                        
                        var randm = $(this).addClass('js-VID' + (i+1));

                        //Gobal call to Brightcove
                        window.brightcove.createExperiences();

                        //instantiate new object, passing the element in as a jQuery object
                        new VideoView($(randm));

                        $debug('js-videoPlayer = ' + i, 'mmmVideoHero'); 
                    });
                },
                error: function () {
                    $debug('     Brightcove error loading....', 'mmmVideoHero');
                }
            });

        });

		var VideoView = function ($element) {

			/**
             * Variables Containing Classes for easy changing
             *
             * @default null
             * @property VIDEO_TRIGGER, VIDEO_FIGURE_CONTAINER, VIDEO_OBJECT_CONTAINER,VIDEO_OBJECT
             * @type string
             */

            this.$element = $element;

            this.VIDEO_TRIGGER = undefined;
            this.VIDEO_FIGURE_CONTAINER = undefined;
            this.VIDEO_OBJECT_CONTAINER = undefined;
            this.VIDEO_OBJECT_WRAPPER = undefined;
            this.VIDEO_OBJECT = undefined; //add logic for <video> tag in iframe for mobile devices
            this.VIDEO_FLAG = 'default'; //Options: 'default' | 'rH-52-Hero with content 100 inset'
            this.videoObjArr = [];

            var self = this;

            VideoView.prototype.videoPlayer = null;

			/**
			 * Tracks whether the component is enabled.
			 *
			 * @default false
			 * @property isEnabled
			 * @type {boolean}
			 * @public
			 */
			this.isEnabled = false;

			this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalResizeListener.getResizeListener()
             * @property GlobalResizeListener
             * @type {jQuery}
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

			this.init();

		};

		//VideoView.prototype.player = null;
		//VideoView.prototype.APIModules = null;
		//VideoView.prototype.videoPlayer = null;

		/**
		 * Initializes the UI Component View
		 * Runs a single setupHandlers call, followeed by createChildren and enable.
		 * Exits early if it is already initialized
		 *
		 * @method init
		 * @return {VideoView}
		 * @private
		 */
		VideoView.prototype.init = function () {
			this
				.setupHandlers()
				.createChildren()
				.enable();
			
			return this;
		};

		/**
		 * Binds the scope of any handler functions
		 * Should only be run on initializiation of the view.
		 *
		 * This creates the event handlers and binds the scope of the JS
		 *
		 * @method setupHandlers
		 * @returns {VideoView}
		 * @private
		 */
		VideoView.prototype.setupHandlers = function () {
			this.onClickHandler = this.onClick.bind(this);
			this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.resizeCheck.bind(this));

			return this;
		};

		/**
		 * Create any child objects or references to DOM elements.
		 * Should only be run on intitialization of the view.
		 *
		 * @method createChildren
		 * @returns {VideoView}
		 * @private
		 */
		VideoView.prototype.createChildren = function () {
			this.VIDEO_TRIGGER = this.$element.find($('.js-videoPlayer-trigger'));
            this.VIDEO_FIGURE_CONTAINER = this.$element.find($('.js-videoFigureContainer'));
            this.VIDEO_OBJECT_CONTAINER = this.$element.find($('.js-videoObjectContainer'));
            this.VIDEO_OBJECT = brightcove.checkFlashSupport() === null ? this.$element.find($('.js-videoObjectContainer iframe')) : this.$element.find($('.js-videoObjectContainer object'));  //add logic for <video> tag in iframe for mobile devices
            this.VIDEO_FLAG = 'default'; //Options: 'default' | 'rH-52-Hero with content 100 inset'

            //grabbing video id
            vID = this.VIDEO_OBJECT.attr('id')
           
            //adding MMM--videoMedia_Play class
			this.VIDEO_TRIGGER.addClass('MMM--videoMedia_Play');

            this.$videoTrigger = this.$element.find(this.VIDEO_TRIGGER);
            this.$videoFigureContainer = this.$element.find(this.VIDEO_FIGURE_CONTAINER);
            this.$videoObjectContainer = this.$element.find(this.VIDEO_OBJECT_CONTAINER);
            this.$videoObject = this.$element.find(this.VIDEO_OBJECT);

            /**
             * Global object - currentVideo stores a referene to the VIDEO_FIGURE_CONTAINER and
             * VIDEO_OBJECT_CONTAINER properties.
			 *
			 * @type object
			 */
			 var self = this;

            window.currentVideo = {
				videoFigureContainer : self.VIDEO_FIGURE_CONTAINER,
				videoObjectContainer : self.VIDEO_OBJECT_CONTAINER,
				videoObject : self.VIDEO_OBJECT
            };

            //confirm if this component is a video in the content 100 inset layout
            if(self.$element.hasClass('rH-52-Hero') && self.$element.parents('.MMM--bleedingEdgeLayout').length > 0){
            	self.VIDEO_FLAG = 'rH-52-Hero with content 100 inset'; 
            	self.VIDEO_DRAGDOWN_CONTAINER = self.$element.parents('.MMM--bleedingEdgeLayout');

            	self.VIDEO_DRAGDOWN_CONTAINER.addClass('rH-52-Hero-with-content-100-inset');

            	window.currentVideo.VIDEO_FLAG = self.VIDEO_FLAG;
            	window.currentVideo.VIDEO_DRAGDOWN_CONTAINER = self.VIDEO_DRAGDOWN_CONTAINER;

            }

            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {VideoView}
         * @publick
         */
		VideoView.prototype.removeChildren = function () {
            this.$videoTrigger = null;
            this.$videoFigureContainer = null;
            this.$videoObjectContainer = null;
            this.$videoObject = null;

            return this;
        };

        /**
         * Enables the component.
         * Performs any event binding to handlers.
         * Exits early if it is already enabled.
         *
         * @method enable
         * @returns {VideoView}
         * @public
         */
		VideoView.prototype.enable = function () {
			var self = this;

			if (this.isEnabled) {
				return this;
			}

			this.isEnable = true;

			//append id to the trigger
			this.VIDEO_TRIGGER.attr('data-video-id', vID);

            self.VIDEO_TRIGGER.on('click', function(event) {
                self.onClickHandler($(this));
            });


			if($('.rH-52-Hero-with-content-100-inset .MMM--videoCloseBtn').length>0){
				$('.rH-52-Hero-with-content-100-inset .MMM--videoCloseBtn').on('click', this.closeVideoBtnHandle);
			}

			return this;
        };

        /**
         * Disables the component.
         * Tears down any event binding to handlers.
         * Exits early if it is already disabled.
         *
         * @method disable
         * @returns {VideoView}
         * @public
         */
		VideoView.prototype.disable = function () {
			if (!this.isEnabled) {
				return this;
			}

			this.isEnabled = false;

			return this;
        };

        /**
         * Destroys the component.
         * Tears down any events, handlers, elements.
         * Should be called when the object should be left unused.
         *
         * @method destory
         * @returns {VideoView}
         * @public
         */
        VideoView.prototype.destroy = function () {
			this.disable()
				.removeChildren();

			return this;
        };

        VideoView.prototype.resizeCheck = function () {
			this.resize();
        };

        /**
         * Sets the Width and Height of the VIDEO_OBJECT.
         * Used with the onClick Method.
         *
         * @method resize
         * @returns {VideoView}
         * @private
         */
        VideoView.prototype.resize = function () {
			var currentHeight = this.$videoFigureContainer.height(),
			currentWidth = this.$videoFigureContainer.width();

			this.$videoObject.height(currentHeight);
			this.$videoObject.width(currentWidth);
			
			//<video> is embed via iframe, need to update src value based on current width/height
			if(brightcove.checkFlashSupport() === null) {
				var iframeSrc = this.$videoObject.attr('src');
				
				this.$videoObject.attr('src', iframeSrc + '&amp;size='+currentWidth+'x'+currentHeight);
			}

			return this;

		};

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //
        // Place events here, use event handlers to access it
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * Clicking the trigger for this method causes the method to set display:none on the image and position:static on the video object.
         * The resize method is fired to resize the video object.
         * The Brightcove play method is fired to start playing the video if the video player is ready.
         */
        VideoView.prototype.onClick = function (e) {
			if (e.preventDefault) {
				e.preventDefault();
			}
			else {
				//needed for IE Support
				e.returnValue = false;
			}

			var self = this,
				videoID = e.attr('data-video-id');

			//Call the .resize() method.
			this.resize();

			this.$videoFigureContainer.css({
				'display' : 'none'
			});

            this.$videoObjectContainer.css({
				'position' : 'static'
			});

			if(this.VIDEO_FLAG === 'rH-52-Hero with content 100 inset'){
				this.VIDEO_DRAGDOWN_CONTAINER.addClass('MMM--Playing');
			}
            //needs to be namespaced correctly for rG-50 4up Tiles so it doesnt break 2838
			//$("div.MMM--carouselListItem_heroOnly .MMM--isOnMobile").detach().prependTo($("div.MMM--subContent .MMM--isOnMobile-rG-50"));
            
            $debug('bcModarray length = ' + bcModArr.length, 'mmmVideoHero');

            // looping through the video IDs to check to play the right one
			for (var i = 0; i < bcModArr.length; i++) {
				$debug('bcModarray length FOR loop  = ' + bcModArr[i][0] + ', bcModArr[i][1] = ' + bcModArr[i][1], 'mmmVideoHero');
				if (bcModArr[i][0] === videoID) {
					 $debug('bcModarray length IFFF = ' + bcModArr.length, 'mmmVideoHero');
        			bcModArr[i][1].play();
        		}
    		}

			/*if (VideoView.videoPlayer) {
				VideoView.videoPlayer.play();
				$msg('inside "play" if-----');
         
			} else {

				if(experienceId) {
					VideoView.player = brightcove.api.getExperience(experienceId);
					VideoView.APIModules = brightcove.api.modules.APIModules;
					VideoView.videoPlayer = VideoView.player.getModule(VideoView.APIModules.VIDEO_PLAYER);
					VideoView.videoPlayer.addEventListener(brightcove.api.events.MediaEvent.STOP, onStop);
					VideoView.videoPlayer.play();
                    $msg('inside "play" else-----');
				}
			}*/

        };

        VideoView.prototype.closeVideoBtnHandle = function(){
        	var self = this;
        	if (VideoView.videoPlayer) {
				VideoView.videoPlayer.pause(true);
				VideoView.videoPlayer.seek('0');
			} else {
				var experienceId = this.$videoObject.attr('id');
				if(experienceId) {
					
					VideoView.player = brightcove.api.getExperience(experienceId);
					VideoView.APIModules = brightcove.api.modules.APIModules;
					VideoView.videoPlayer = VideoView.player.getModule(VideoView.APIModules.VIDEO_PLAYER);
					VideoView.videoPlayer.addEventListener(brightcove.api.events.MediaEvent.STOP, onStop);
					VideoView.videoPlayer.pause(true);
					VideoView.videoPlayer.seek('0');
				}
			}

			if(currentVideo.VIDEO_FLAG === 'rH-52-Hero with content 100 inset'){
				currentVideo.VIDEO_DRAGDOWN_CONTAINER.removeClass('MMM--Playing');
			}

			// Stopped is at the end, consider it a pseudo-complete
			$(currentVideo.videoFigureContainer).css({
				'display' : 'block'
			});

			$(currentVideo.videoObjectContainer).css({
				'position' : 'absolute'
			});
        };
        /**
         * Global method for access to Brightcove API
         *
         * @method onTemplateLoad
         * @returns {window}
         * @public
         */
		window.onTemplateLoad = function (experienceId) {
            $debug('====on Template load fired ===='+experienceId, 'mmmVideoHero');
            player = brightcove.api.getExperience(experienceId);
            bcMod = player.getModule(brightcove.api.modules.APIModules.VIDEO_PLAYER);
			APIModules = player.getModule(brightcove.api.modules.APIModules.EXPERIENCE);
            bcModArr.push([experienceId, bcMod]);

            $debug('onTemplateLoad bcModArr' + bcModArr.length + ', experienceId ' + experienceId + ', bcMod ' + bcMod, 'mmmVideoHero');
            $debug('====on Template load fired getting EXPERIENCE ===='+brightcove.api.modules.APIModules.EXPERIENCE, 'mmmVideoHero');
		};

        /**
         * Global method for access to Brightcove addEventListeners.
         *
         * @method onTemplateReady
         * @returns {window}
         * @public
         */
		window.onTemplateReady = function (evt) {
			
			//VideoView.videoPlayer = VideoView.player.getModule(VideoView.APIModules.VIDEO_PLAYER);
			//VideoView.videoPlayer.addEventListener(brightcove.api.events.MediaEvent.STOP, onStop);

            $debug('====on Template ready fired videoPlayer====', 'mmmVideoHero');

        	for (var i = 0; i < bcModArr.length; i++) {
				//bcModArr[i][1].cueVideoByID(bcModArr[i][0]);

				bcModArr[i][1].addEventListener(brightcove.api.events.MediaEvent.PLAY, function (event) {
					onPlay(event);
				});

				bcModArr[i][1].addEventListener(brightcove.api.events.MediaEvent.STOP, function (event) {
					onStop(event);
				});
			}
        };

        window.onPlay = function (ev) {            
            var id = ev.target.experience.id;
            $debug('    on play fired... event id = ' + id, 'mmmVideoHero');

			for (var i = 0; i < bcModArr.length; i++) {
				if (bcModArr[i][0] !== id) {
					bcModArr[i][1].pause(true);
				}
			}
        };
        /**
         * Global method for access Brightcove event listeners.
         * On video complete, the video object is positioned absolutely and
         * pushed off the screens view.  The image is set to display:block.
         *
         * @method onStop
         * @returns {window}
         * @public
         */
		window.onStop = function (evt) {
			var id = evt.target.experience.id,
				vidObj = $('.js-videoPlayer').find('.js-videoObjectContainer');
			if ( (evt.position > ((evt.media.length/1000)-0.1) ) || ( evt.position === 0 ) )  {
				if(currentVideo.VIDEO_FLAG === 'rH-52-Hero with content 100 inset'){
					currentVideo.VIDEO_DRAGDOWN_CONTAINER.removeClass('MMM--Playing');
				}
   				$debug('    Window player onStop id = ' + id+ ', currentVideo.videoObject id = '+ $(currentVideo.videoObject).attr('id'), 'mmmVideoHero');

   				vidObj.each(function (index, el) {
					$debug('    Window player onStop vidObj= ' + $(this).children().first().attr('id'), 'mmmVideoHero');
					$(this).css({
						'position' : 'absolute'
					});
					$(this).prev().css({
						'display' : 'block'
					});

				});

				// Stopped is at the end, consider it a pseudo-complete
				//$(currentVideo.videoFigureContainer).css({
				//$('.js-videoFigureContainer').css({
				//	'display' : 'block'
				//});
				//$(currentVideo.videoObjectContainer).css({
				//$('.js-videoObjectContainer').css({
				//	'position' : 'absolute'
				//});
                
			}
		};

		return VideoView;

	});

}(MMMRequire));